/**
 * Generic toast notifications using react-hot-toast.
 * Export Toaster (mount once in app) and toast helpers for use anywhere.
 */
import { Toaster as HotToaster } from 'react-hot-toast';

const toastOptions = {
    duration: 4000,
    position: 'top-center',
    style: {
        borderRadius: '8px',
        padding: '12px 16px',
        fontFamily: "'Inter'",
        fontSize: '14px',
    },
    success: {
        iconTheme: { primary: '#25D366', secondary: '#fff' },
    },
    error: {
        iconTheme: { primary: '#ef4444', secondary: '#fff' },
    },
    loading: {
        iconTheme: { primary: '#3b82f6', secondary: '#fff' },
    },
};

/**
 * Mount once at app root (e.g. in demo.jsx).
 */
export function Toaster() {
    return (
        <HotToaster
            toastOptions={toastOptions}
            containerStyle={{ top: 24 }}
        />
    );
}

/**
 * Re-export toast from react-hot-toast so the app uses a single import.
 * Use: toast.success('Saved'), toast.error('Failed'), toast.loading('...'), etc.
 */
export { default as toast } from 'react-hot-toast';
